import { ClickoutUrl } from '@/helpers/clickout-helper';

import { useExperiment } from '@/libraries/experiment';
import { getExperimentAffiliateTag } from '@/libraries/experiment/experiment-affiliation';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { storeToRefs } from 'pinia';

const ELIGIBLE_PROVIDERS = ['atp', 'amp', 'prv'];
const US_ONLY_PROVIDERS = ['hlu'];

export function useGridMoreInfoExp() {
	const { activeVariantWithControlGroup: variant, experimentInfo } = useExperiment('EXP_GRID_MORE_INFO_REDESIGN_V2');

	const { country } = storeToRefs(useLanguageStore());

	function setGridMoreInfoTags(url: ClickoutUrl, placement: 'ft' | 'ro', shortName: string, inline?: boolean) {
		if (!variant.value || inline) return url;
		const isEligible =
			ELIGIBLE_PROVIDERS.includes(shortName) || (US_ONLY_PROVIDERS.includes(shortName) && country.value === 'US');
		if (!isEligible) return url;

		const affiliationShortId = experimentInfo.value.affiliationShortId as string;

		const tag = getExperimentAffiliateTag({
			affiliationShortId,
			variant: variant.value,
			country: country.value,
			placement,
			providerShortName: shortName,
		});

		return url.set('uct_ctag', tag);
	}

	return {
		setGridMoreInfoTags,
	};
}
